'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pistachio7 = exports.pistachio7 = '#719E4C';
var pistachio6 = exports.pistachio6 = '#86AD52';
var pistachio5 = exports.pistachio5 = '#9BBC59';
var pistachio4 = exports.pistachio4 = '#B0CA5F';
var pistachio3 = exports.pistachio3 = '#C2D26B';
var pistachio2 = exports.pistachio2 = '#D4DA76';
var pistachio1 = exports.pistachio1 = '#E5E281';
var pistachio = {
  7: pistachio7,
  6: pistachio6,
  5: pistachio5,
  4: pistachio4,
  3: pistachio3,
  2: pistachio2,
  1: pistachio1
};
exports.default = pistachio;